import type { FC, MouseEvent } from "react";
import { Text } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { containerStyle } from "./HotspotCluster.css";
import { elevations } from "@huub-web/ui/theme/css/elevations.css";

export type HotspotClusterProps = {
  id: string;
  title?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
};

export const HotspotCluster: FC<HotspotClusterProps> = ({
  id,
  title,
  onClick,
}) => (
  <button
    type="button"
    id={id}
    className={mergeClasses(containerStyle, elevations.m)}
    onClick={onClick}
  >
    <Text variant="bodyXS" noWrap>
      {title}
    </Text>
  </button>
);
